import script from "./WebPageForDownload.vue?vue&type=script&setup=true&lang=js"
export * from "./WebPageForDownload.vue?vue&type=script&setup=true&lang=js"

import "./WebPageForDownload.vue?vue&type=style&index=0&id=64a4632f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64a4632f"]])

export default __exports__